import { render, staticRenderFns } from "./AdditionalRolesRow.vue?vue&type=template&id=2ac2ded6&scoped=true"
import script from "./AdditionalRolesRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdditionalRolesRow.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2ded6",
  null
  
)

export default component.exports